import { _api } from '@/utils/apiAxios';

const state = {
  status: {
    loading: false,
    success: false,
    error: false,
  },
  currentStoredMethods: [],
  selectedMethod: {},
};

const getters = {};

const mutations = {
  setCurrentStoredMethods(state, currentStoredMethods) {
    state.currentStoredMethods = currentStoredMethods;
  },
  setStatus(state, status) {
    state.status = status;
  },
  setSelectedMethod(state, selectedMethod) {
    state.selectedMethod = selectedMethod;
  },
};

const actions = {
  getStoredDeposits({ commit }, currentMethod) {
    commit('setStatus', { loading: true });
    commit('setCurrentStoredMethods', []);
    commit('setSelectedMethod', {});

    _api
      .get('deposit' + currentMethod.endpoint)
      .then(res => {
        if (res.data.IsSuccess) {
          currentMethod.data = res.data.Data;
        }
      })
      .finally(() => {
        commit('setStatus', { loading: false });
      });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
